/// <reference path="../../global/fn.js" />

(function ($) {
    jQuery.widget("nsp.asideMenu", {
        options: {},
        _setOption: function (key, value) {
            this.options[key] = value;
            this._update();
        },
        _create: function () {
            this._iniVars();

            this._stickyMenu();


            if (!this.onlySticky) {
                this._scrollOnClick();

                setTimeout(() => {
                    this._checkActiveSection();
                }, 100);

                $(window).on("scroll", () => {
                    this._checkActiveSection();
                });
            }
        },

        _iniVars: function () {
            this.wrap = this.element;
            this.onlySticky = this.wrap.hasClass("only-sticky") ? true : false;
            this.ul = $("ul", this.wrap);
            this.liItems = $("li", this.wrap);
            this.hrefs = $("ul li a", this.wrap);
        },

        _scrollOnClick: function () {
            
            if (!this.onlySticky) {
                this.hrefs.on("click", function (e) {
                    e.preventDefault();

                    $(document).off("scroll");

                    var target = this.hash,
                        target = $(target);

                    $("html, body")
                        .stop()
                        .animate(
                            {
                                scrollTop: target.offset().top - 120,
                            },
                            600,
                            "swing"
                        );
                });
            }
        },

        _checkActiveSection: function () {
            
            if (!this.onlySticky) {
                var menu_pos =
                    this.element.offset().top + this.element.scrollTop() + 40;

                var sections = $(".s-hr__section");

                sections.each(function () {
                    if (menu_pos >= $(this).offset().top) {
                        var activeId = $(this).attr("id");
                        var activeHref = $('a[href="#' + activeId + '"]');
                        var activeLi = activeHref.parent();

                        $(".b-aside-menu li a").removeClass("active");

                        activeHref.addClass("active");
                    }
                });
            }
        },

        _stickyMenu: function () {
            this.element.stick_in_parent({
                offset_top: api.fn.getHeaderHeight(),
            });
        },
    });
})(jQuery);
